import { useEffect, useState } from "react";
import {
  PubTournament,
  PubType,
  TimerInfoState,
} from "../../../../../api/types";
import {
  CircularProgress,
  TournamentStateInfoBlindItem,
  TournamentStateInfoBlindWrapper,
  TournamentStateInfoLevel,
  TournamentStateInfoLevelWrapper,
  TournamentStateInfoTimerWrapper,
  TournamentStateInfoWrapper,
  TournamentStateTimerBox,
} from "./styled";
import {
  calculateTimeAtStart,
  calculateTimes,
} from "../../../../../utils/timer";
import { currentTimeState } from "../../../../../recoil/app";
import { useRecoilValue } from "recoil";

interface TournamentStateInfoProps {
  tournament: PubTournament;
  updateData: () => void;
  pubType: PubType;
}
const TournamentStateInfo = ({
  tournament,
  updateData,
  pubType,
}: TournamentStateInfoProps) => {
  const radius = 28.5;
  const circumference = 2 * Math.PI * radius;
  const currentTime = useRecoilValue(currentTimeState);
  const [timer, setTimer] = useState<TimerInfoState>();

  useEffect(() => {
    if (!tournament) return;

    if (tournament.timerDto) {
      const time = calculateTimes(
        tournament.timerDto,
        tournament.structure,
        pubType === "RUNNER",
      );
      if (time && time.overStack < 1) {
        setTimer(time);
      }
    } else {
      const startDate = new Date(tournament.startDate);
      const time = calculateTimeAtStart(
        startDate,
        new Date(tournament.createdAt),
        tournament.structure[0],
        tournament.structure[1],
      );
      setTimer(time);
    }
  }, [tournament, currentTime]);

  const formatTime = (value: string | undefined) => {
    if (!value) return "";
    if (value.includes("hour")) {
      if (+value.split("hour")[0] <= 24) {
        return value;
      }
      const day = (+value.split("hour")[0] / 24).toFixed();
      return `${day}day`;
    }
    return value;
  };

  const getEntryButtonText = (): string => {
    const totalCapacity =
      tournament.adOnUserCount +
      tournament.entryUserCount +
      tournament.reBuyInUserCount;

    return `${tournament.userCount}/${totalCapacity}`;
  };

  const blindList = [
    {
      name: `${timer?.currentLevel.type === "READY" ? "시작" : "현재"} BLIND`,
      value:
        timer?.currentLevel.type === "BREAK"
          ? "BREAK"
          : `${timer?.currentLevel.smallBlind} / ${timer?.currentLevel.bigBlind} (${timer?.currentLevel.ante})`,
    },
    {
      name: "다음 BLIND",
      value:
        timer?.nextLevel?.type === "BREAK"
          ? "BREAK"
          : `${timer?.nextLevel?.smallBlind} / ${timer?.nextLevel?.bigBlind} (${timer?.nextLevel?.ante})`,
    },
    {
      name: "레지 마감",
      value: `${tournament.registerDeadlineLevel}LV`,
    },
  ];

  const getTournamentStateText = () => {
    if (tournament?.isEnd) return "종료된 토너먼트";
    if (timer?.currentLevel.type === "BREAK") {
      const ord = timer.currentLevel.ord;
      const currentIndex = tournament.structure.findIndex(
        (item) => item.ord === ord,
      );
      const prevLevel = tournament.structure[currentIndex - 1]?.level;
      if (!prevLevel) {
        const prevPrevLevel = tournament.structure[currentIndex - 2]?.level;
        return `BREAK (LV${prevPrevLevel})`;
      }
      return `BREAK (LV${prevLevel})`;
    }
    if (timer?.currentLevel.type === "READY") return "준비중";
    return `LV ${timer?.currentLevel.level}`;
  };

  return (
    <TournamentStateInfoWrapper>
      {timer && (
        <>
          <TournamentStateInfoTimerWrapper>
            <TournamentStateTimerBox>
              <CircularProgress>
                <circle className="background" r={28.5} cx="28.5" cy="28.5" />
                <circle
                  className="progress"
                  r={28.5}
                  cx="28.5"
                  cy="28.5"
                  stroke="url(#gradient)"
                  strokeWidth="5"
                  strokeDasharray={circumference}
                  strokeDashoffset={
                    timer.currentLevel.type === "READY"
                      ? 0
                      : (circumference * -timer.progress) / 100
                  }
                />
                <defs>
                  <radialGradient
                    id="gradient"
                    cx="95%"
                    cy="50%"
                    r="80%"
                    fx="100%"
                    fy="50%"
                  >
                    <stop offset="0%" stopColor="#FFFFFF" />
                    <stop offset="49.5%" stopColor="#FF8787" />
                    <stop offset="100%" stopColor="#FF0000" />
                  </radialGradient>
                </defs>
              </CircularProgress>
              <div className="time">
                {formatTime(timer.remainingTimeInCurrentLevel)}
              </div>
            </TournamentStateTimerBox>
            <TournamentStateInfoLevelWrapper>
              <TournamentStateInfoLevel>
                {getTournamentStateText()}
              </TournamentStateInfoLevel>
              <div className="entry">현재 엔트리 {getEntryButtonText()}</div>
            </TournamentStateInfoLevelWrapper>
            <img
              src="/image-web/tournament/reset.svg"
              alt="reset"
              onClick={() => updateData()}
            />
          </TournamentStateInfoTimerWrapper>
          <TournamentStateInfoBlindWrapper>
            {blindList.map((item, index) => (
              <TournamentStateInfoBlindItem key={index}>
                <div className="name">{item.name} </div>
                <div className="blind">{item.value}</div>
              </TournamentStateInfoBlindItem>
            ))}
          </TournamentStateInfoBlindWrapper>
        </>
      )}
    </TournamentStateInfoWrapper>
  );
};

export default TournamentStateInfo;
